// extracted by mini-css-extract-plugin
export default {"container":"MenuSubitem_container__05RBU","icon":"MenuSubitem_icon__LjlOX","title":"MenuSubitem_title__0evbK","selected":"MenuSubitem_selected__7pv4e"};